import React from 'react';
import { Routes, Route } from 'react-router-dom';
import App from "./App.tsx";
import SharePage from "./SharedPage.tsx";

const AppRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<App />} />
            <Route path="/share/:uuid" element={<SharePage />} />
        </Routes>
    );
};

export default AppRoutes;